<form [formGroup]="acceptForm" class="partner-add-form" (ngSubmit)="submit()">
  <div class="partner-add-form-header">
    <span class="partner-add-form-title">{{ 'partner.accept.form.title' | translate : { fgbdefault: 'Accept Partner' } }}</span>
  </div>

  <div class="partner-add-form-fields">
    <p class="partner-add-form-description">
      {{
        'partner.form.description'
          | translate
            : {
                fgbdefault: 'Please enter the partner details received via email and click "Accept" to accept partner request.'
              }
      }}
    </p>
    <div class="partner-add-form-field-row">
      <div class="partner-add-form-field">
        <label class="partner-add-form-field-label" for="partner-accept-code">{{
          'partner.add.form.code.label' | translate : { fgbdefault: 'Partner Code' }
        }}</label>
        <input id="partner-accept-code" formControlName="code" type="text" class="partner-add-form-field-input" />
      </div>
      <div class="partner-add-form-field">
        <label class="partner-add-form-field-label" for="partner-accept-secret-code">{{
          'partner.accept.form.secretcode.label' | translate : { fgbdefault: 'Partner Secret Code' }
        }}</label>
        <input
          id="partner-accept-secret-code"
          formControlName="secretCode"
          type="text"
          class="partner-add-form-field-input"
        />
      </div>
    </div>
  </div>

  <div class="partner-add-form-error">
    <fgbcl-errors></fgbcl-errors>
  </div>

  <div class="partner-add-form-actions">
    <button type="button" class="btn-text-danger" (click)="close(); $event.preventDefault()">
      {{ 'modal.cancel' | translate }}
    </button>
    <button type="submit" class="btn-filled-success" [disabled]="acceptForm.invalid">
      {{ 'modal.confirm' | translate }}
    </button>
  </div>
</form>
